// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk
 *
 * TypeScript SDK for the Inferrex self-healing integration infrastructure API.
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { InferrexClientConfig } from '@inferrex/contracts';
import { HttpClient } from './http.js';
import { AdminClient } from './generated/admin.js';
import { PlatformClient } from './generated/platform.js';
import { CoreClient } from './generated/core.js';
import { Cli_snippetsClient } from './generated/cli_snippets.js';
import { ProvisioningClient } from './generated/provisioning.js';
import { LicenceClient } from './generated/licence.js';
import { ConnectionsClient } from './generated/connections.js';
import { MappingsClient } from './generated/mappings.js';
import { CredentialsClient } from './generated/credentials.js';
import { PipelinesClient } from './generated/pipelines.js';
import { JobsClient } from './generated/jobs.js';
import { IntelligenceClient } from './generated/intelligence.js';
import { MigrationClient } from './generated/migration.js';
import { GamificationClient } from './generated/gamification.js';
import { ArchivalClient } from './generated/archival.js';
import { RetrievalClient } from './generated/retrieval.js';
import { LibraryClient } from './generated/library.js';
import { SettingsClient } from './generated/settings.js';
import { SearchClient } from './generated/search.js';
import { NotificationsClient } from './generated/notifications.js';
import { TermsClient } from './generated/terms.js';
import { HealsClient } from './generated/heals.js';
import { Unified_apiClient } from './generated/unified_api.js';
import { OnboardingClient } from './generated/onboarding.js';
import { PricingClient } from './generated/pricing.js';
import { Platform_configClient } from './generated/platform_config.js';
import { OauthClient } from './generated/oauth.js';
import { MetaClient } from './generated/meta.js';
import { Event_subscriptionsClient } from './generated/event_subscriptions.js';
import { BillingClient } from './generated/billing.js';
import { GovernanceClient } from './generated/governance.js';
import { Connector_libraryClient } from './generated/connector_library.js';
import { MonitoringClient } from './generated/monitoring.js';
import { WorkflowsClient } from './generated/workflows.js';
import { OperationsClient } from './generated/operations.js';
import { Data_protectionClient } from './generated/data_protection.js';
import { Golden_recordClient } from './generated/golden_record.js';
import { SsoClient } from './generated/sso.js';
import { WorkspaceClient } from './generated/workspace.js';
import { SchemaClient } from './generated/schema.js';
import { PortalClient } from './generated/portal.js';
import { AssistantClient } from './generated/assistant.js';
import { RbacClient } from './generated/rbac.js';
import { CliClient } from './generated/cli.js';

export class InferrexClient {
  public readonly admin: AdminClient;
  public readonly platform: PlatformClient;
  public readonly core: CoreClient;
  public readonly cli_snippets: Cli_snippetsClient;
  public readonly provisioning: ProvisioningClient;
  public readonly licence: LicenceClient;
  public readonly connections: ConnectionsClient;
  public readonly mappings: MappingsClient;
  public readonly credentials: CredentialsClient;
  public readonly pipelines: PipelinesClient;
  public readonly jobs: JobsClient;
  public readonly intelligence: IntelligenceClient;
  public readonly migration: MigrationClient;
  public readonly gamification: GamificationClient;
  public readonly archival: ArchivalClient;
  public readonly retrieval: RetrievalClient;
  public readonly library: LibraryClient;
  public readonly settings: SettingsClient;
  public readonly search: SearchClient;
  public readonly notifications: NotificationsClient;
  public readonly terms: TermsClient;
  public readonly heals: HealsClient;
  public readonly unified_api: Unified_apiClient;
  public readonly onboarding: OnboardingClient;
  public readonly pricing: PricingClient;
  public readonly platform_config: Platform_configClient;
  public readonly oauth: OauthClient;
  public readonly meta: MetaClient;
  public readonly event_subscriptions: Event_subscriptionsClient;
  public readonly billing: BillingClient;
  public readonly governance: GovernanceClient;
  public readonly connector_library: Connector_libraryClient;
  public readonly monitoring: MonitoringClient;
  public readonly workflows: WorkflowsClient;
  public readonly operations: OperationsClient;
  public readonly data_protection: Data_protectionClient;
  public readonly golden_record: Golden_recordClient;
  public readonly sso: SsoClient;
  public readonly workspace: WorkspaceClient;
  public readonly schema: SchemaClient;
  public readonly portal: PortalClient;
  public readonly assistant: AssistantClient;
  public readonly rbac: RbacClient;
  public readonly cli: CliClient;

  constructor(config: InferrexClientConfig) {
    const http = new HttpClient(config);
    this.admin = new AdminClient(http);
    this.platform = new PlatformClient(http);
    this.core = new CoreClient(http);
    this.cli_snippets = new Cli_snippetsClient(http);
    this.provisioning = new ProvisioningClient(http);
    this.licence = new LicenceClient(http);
    this.connections = new ConnectionsClient(http);
    this.mappings = new MappingsClient(http);
    this.credentials = new CredentialsClient(http);
    this.pipelines = new PipelinesClient(http);
    this.jobs = new JobsClient(http);
    this.intelligence = new IntelligenceClient(http);
    this.migration = new MigrationClient(http);
    this.gamification = new GamificationClient(http);
    this.archival = new ArchivalClient(http);
    this.retrieval = new RetrievalClient(http);
    this.library = new LibraryClient(http);
    this.settings = new SettingsClient(http);
    this.search = new SearchClient(http);
    this.notifications = new NotificationsClient(http);
    this.terms = new TermsClient(http);
    this.heals = new HealsClient(http);
    this.unified_api = new Unified_apiClient(http);
    this.onboarding = new OnboardingClient(http);
    this.pricing = new PricingClient(http);
    this.platform_config = new Platform_configClient(http);
    this.oauth = new OauthClient(http);
    this.meta = new MetaClient(http);
    this.event_subscriptions = new Event_subscriptionsClient(http);
    this.billing = new BillingClient(http);
    this.governance = new GovernanceClient(http);
    this.connector_library = new Connector_libraryClient(http);
    this.monitoring = new MonitoringClient(http);
    this.workflows = new WorkflowsClient(http);
    this.operations = new OperationsClient(http);
    this.data_protection = new Data_protectionClient(http);
    this.golden_record = new Golden_recordClient(http);
    this.sso = new SsoClient(http);
    this.workspace = new WorkspaceClient(http);
    this.schema = new SchemaClient(http);
    this.portal = new PortalClient(http);
    this.assistant = new AssistantClient(http);
    this.rbac = new RbacClient(http);
    this.cli = new CliClient(http);
  }
}
